module.exports = __webpack_public_path__ + "static/media/QualityPic02.2d911fb0.jpg";